export default __webpack_public_path__ + "static/media/133.d63cbd62.webp";